import { CSSProperties } from 'react'

const HeadsetOff = ({ style, color = '#C83629' }: { style?: CSSProperties; color?: string }) => {
    return (
        <div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
                <g id="headset_off">
                    <g id="Vector">
                        <path
                            d="M10.5917 2.78752C13.8167 2.78752 16.4251 5.39585 16.4251 8.62085V9.45418H13.0917V9.59585L14.6167 11.1208H16.4251V12.9292L18.0917 14.5958V8.62085C18.0917 4.47918 14.7334 1.12085 10.5917 1.12085C8.90841 1.12085 7.35841 1.67918 6.10841 2.62085L7.30008 3.81252C8.23341 3.16252 9.36675 2.78752 10.5917 2.78752Z"
                            fill={color}
                        />
                        <path
                            d="M2.34175 1.20418L1.16675 2.37918L3.94175 5.15418C3.40008 6.19585 3.09175 7.37085 3.09175 8.62085V14.4542C3.09175 15.3708 3.84175 16.1208 4.75841 16.1208H8.09175V9.45418H4.75841V8.62085C4.75841 7.83752 4.91675 7.09585 5.19175 6.41252L13.0917 14.3125V16.1208H14.9001L15.7334 16.9542H10.5917V18.6208H16.4251C16.7084 18.6208 16.9667 18.5458 17.2001 18.4208L17.6584 18.8792L18.8334 17.7042L2.34175 1.20418ZM6.42508 11.1208V14.4542H4.75841V11.1208H6.42508Z"
                            fill={color}
                        />
                    </g>
                </g>
            </svg>
        </div>
    )
}

export default HeadsetOff
